// extracted by mini-css-extract-plugin
module.exports = {"resultsChart":"styles_resultsChart__3iWHz","slideInFromRight":"styles_slideInFromRight__3VtDZ"};